import { render } from "./ListDocumentsView.vue?vue&type=template&id=356b1dba&scoped=true&ts=true"
import script from "./ListDocumentsView.vue?vue&type=script&lang=ts"
export * from "./ListDocumentsView.vue?vue&type=script&lang=ts"

import "./ListDocumentsView.vue?vue&type=style&index=0&id=356b1dba&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356b1dba"]])

export default __exports__